import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {IndicationActions, IndicationReducer} from '../store';
import {Observable} from 'rxjs';
import {AppState} from '@core/reducers';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';
import {ActivatedRoute} from '@angular/router';
import {LanguageEnum} from '@core/enums/language.enum';

@Component({
    selector: 'app-indication-container',
    templateUrl: './indication-container.component.html',
    styleUrls: ['./indication-container.component.scss']
})
export class IndicationContainerComponent implements OnInit {

    indications$: Observable<IndicationBasicModel[]> = this.store.select(IndicationReducer.indicationsSelector);
    language: LanguageEnum | undefined;

    constructor(private store: Store<AppState>, private route: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.route.queryParamMap.subscribe(params => {
            this.language = params.get('l') as LanguageEnum;
            this.store.dispatch(IndicationActions.GetIndications({language: this.language}));
        });
    }

}
